import { createSelector } from 'reselect';
import get from 'lodash/get';
import { SCOPE } from './types';

const selector = state => get(state, SCOPE);
export default selector;

export const sharingResponseSelector = createSelector(
  selector,
  (store) => {
    const { response } = store;
    if (!response) {
      return null;
    }
    const { state, id } = response;
    return {
      state: JSON.parse(state),
      id,
    };
  },
);

export const sharingIsFetchingSelector = createSelector(
  selector,
  store => (store.isFetching),
);
